/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Nda_Signed_Email_NoteInputs */



/**
* | output |
* | --- |
* | "A copy was emailed to {email}." |
*
* @param {Nda_Signed_Email_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_signed_email_note = /** @type {((inputs: Nda_Signed_Email_NoteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Signed_Email_NoteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Une copie a été envoyée à ${i?.email}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se envió una copia a ${i?.email}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Uma cópia foi enviada para ${i?.email}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Una copia è stata inviata a ${i?.email}.`)
	return /** @type {LocalizedString} */ (`A copy was emailed to ${i?.email}.`)
});